import { useState } from "react";
import { useApp } from "@/context/AppContext";
import { MapPin, Check } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const COUNTRIES = [
  { code: "IN", label: "India", flag: "🇮🇳" },
  { code: "US", label: "United States", flag: "🇺🇸" },
  { code: "AE", label: "UAE", flag: "🇦🇪" },
  { code: "GB", label: "United Kingdom", flag: "🇬🇧" },
  { code: "DEFAULT", label: "Other / Global", flag: "🌐" },
];

export default function LocationBadge() {
  const { location, changeCountry } = useApp();
  const [open, setOpen] = useState(false);
  if (!location) return null;
  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="location-badge"
          className="flex items-center gap-1.5 text-xs text-slate-600 hover:text-slate-900 transition-colors rounded-full px-3 py-1.5 border border-slate-200 bg-slate-100"
        >
          <MapPin className="h-3.5 w-3.5 text-asf-orange" />
          <span className="hidden sm:inline">{location.flag}</span>
          <span>{location.country_name}</span>
          <span className="font-mono text-asf-orange">{location.currency}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-slate-100 border-slate-200 text-slate-900">
        <div className="px-2 py-1.5 text-[11px] text-slate-500">Change location & currency</div>
        {COUNTRIES.map((c) => (
          <DropdownMenuItem
            key={c.code}
            data-testid={`country-option-${c.code}`}
            onClick={() => changeCountry(c.code)}
            className="cursor-pointer focus:bg-slate-200 focus:text-slate-900 gap-2"
          >
            <span>{c.flag}</span>
            <span className="flex-1">{c.label}</span>
            {location.country === c.code && <Check className="h-4 w-4 text-asf-orange" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
